module.exports = __webpack_public_path__ + "img/build_selected.fc23c802.png";